/* datepicker.js */
/** file contains the JS functionality for the `<x-input.datepicker />`-component */

export default function datePicker(emitEvent = false, name = null) {
    return {
        emitEvent: emitEvent,
        name: name,
        showDatepicker: false,
        datepickerDisabled: false,
        datepickerValue: '',
        dateFormat: 'D d M Y',
        month: '',
        year: '',
        no_of_days: [],
        blankdays: [],
        MONTH_NAMES: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
        ],
        DAYS: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        initDate(dateValue = null) {
            let dayValue;
            if (dateValue) {
                dayValue = new Date(Date.parse(dateValue));
                this.month = dayValue.getMonth();
                this.year = dayValue.getFullYear();
                this.datepickerValue = this.formatDateForDisplay(dayValue);
                this.datepickerDisabled = true;
            } else {
                dayValue = new Date();
                this.month = dayValue.getMonth();
                this.year = dayValue.getFullYear();
                this.datepickerValue = '';
            }
        },
        formatDateForDisplay(date) {
            /* fix for The specified value \"NaN\" cannot be parsed, or is out of range.","source":"rendering" */
            if (!date) {
                return '';
            }
            const formattedDay = this.DAYS[date.getDay()];
            const formattedDate = ('0' + date.getDate()).slice(-2); // appends 0 (zero) in single digit date
            const formattedShortDate = formattedDate.startsWith('0') ? formattedDate.slice(-1) : formattedDate;
            const formattedMonth = this.MONTH_NAMES[date.getMonth()];
            const formattedMonthInNumber = ('0' + (parseInt(date.getMonth()) + 1)).slice(-2);
            const formattedYear = date.getFullYear();
            if (this.dateFormat === 'DD.MM.YYYY') {
                return `${formattedDate}.${formattedMonthInNumber}.${formattedYear}`; // 02.04.2021
            }
            if (this.dateFormat === 'YYYY-MM-DD') {
                return `${formattedYear}-${formattedMonthInNumber}-${formattedDate}`; // 2021-04-02
            }
            if (this.dateFormat === 'D d M Y') {
                return `${formattedDay}. ${formattedShortDate} ${formattedMonth} ${formattedYear}`; // Do 2. Februar 2021
            }
            return `${formattedDay} ${formattedDate} ${formattedMonth} ${formattedYear}`;
        },
        isSelectedDate(date) {
            const d = new Date(this.year, this.month, date);
            return this.datepickerValue === this.formatDateForDisplay(d);
        },
        isToday(date) {
            const today = new Date();
            const d = new Date(this.year, this.month, date);
            return today.toDateString() === d.toDateString();
        },
        getDateValue(date) {
            const selectedDate = new Date(this.year, this.month, date);
            this.datepickerValue = this.formatDateForDisplay(selectedDate);
            // this.$refs.date.value = selectedDate.getFullYear() + "-" + ('0' + formattedMonthInNumber).slice(-2) + "-" + ('0' + selectedDate.getDate()).slice(-2);
            this.isSelectedDate(date);
            this.showDatepicker = false;
            if (this.emitEvent) {
                /* eslint-disable no-undef */
                Livewire.emit('datepickerChanged', {
                    type: this.name,
                    datestring: `${this.year}-${this.month + 1}-${date}`,
                });
            }
        },
        getNoOfDays() {
            const daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
            // find where to start calendar day of week
            const dayOfWeek = new Date(this.year, this.month).getDay();
            const blankdaysArray = [];
            for (let i = 1; i <= dayOfWeek; i++) {
                blankdaysArray.push(i);
            }
            const daysArray = [];
            for (let i = 1; i <= daysInMonth; i++) {
                daysArray.push(i);
            }
            this.blankdays = blankdaysArray;
            this.no_of_days = daysArray;
        },
        removeDate() {
            this.datepickerValue = null;
            if (this.emitEvent) {
                /* eslint-disable no-undef */
                Livewire.emit('datepickerRemoved', {
                    type: this.name,
                });
            }
        },
    };
}
